import { useEffect, useRef } from 'react';
import lottie from 'lottie-web';

const useAnimation = (animationData) => {
  const animationContainer = useRef(null);

  useEffect(() => {
    if (animationData) {
      lottie.loadAnimation({
        container: animationContainer.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData,
      });
    }
  }, [animationData]);

  return animationContainer;
};

export default useAnimation;
